// extracted by mini-css-extract-plugin
export var card = "_t6-0";